import usegetdata from '../../Hooks/useGetData';
import { Get_All_Users_Devices, Get_Error, logout_session_One_Device_Type } from '../Types';
import { UpdateProductdata } from '../../Hooks/useUpdateData';

// Users Devices
export const GetAllUserDevicesAction = () => async (dispatch) => {
  try {
    const res = await usegetdata(`/api/v1/userdevices/AllDevices`);

    dispatch({
      type: Get_All_Users_Devices,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e + 'error',
    });
  }
};

export const Logoutsession_one_Device = (userId, deviceId) => async (dispatch) => {
  try {
    const res = await UpdateProductdata(`/api/v1/userdevices/${userId}/devices/${deviceId}/logout`);

    dispatch({
      type: logout_session_One_Device_Type,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e + 'error',
    });
  }
};
